<template>
  <div class="business-container">
    <div class="top-box">
      <p class="title">我们能为您提供什么服务？</p>
      <p class="desc">
        天科智友为您打造专业、个性的智能营销SAAS服务平台，提供业财融合、O2O联动、穿透研产销的生态产业链服务。
      </p>
    </div>
    <div class="content-box">
      <div class="title wow fadeInLeft" data-wow-delay="0.2s">
        业务模式及服务
      </div>
      <div class="content">
        <div
          class="desc wow fadeInLeft"
          data-wow-delay="0.2s"
          data-wow-offset="100"
        >
          以大数据和人工智能为抓手，依托强大的数智化营销平台，提供业财一体化的招商、风控和穿透式推广服务。
        </div>
        <div
          class="detail wow fadeInRight"
          data-wow-delay="0.2s"
          data-wow-offset="200"
        >
          <div class="item-box">
            <div class="img-box">
              <img src="~@/assets/images/bar_chart.png" />
            </div>
            <div class="desc-box">
              <p class="tit">自由职业营销平台服务</p>
              <p class="info">
                赋能B2C和C2C服务场景，为自由职业者聚集资源和能力，强化C端服务竞争优势，实现智能化精准营销。
              </p>
            </div>
          </div>
          <div class="item-box">
            <div class="img-box">
              <img src="~@/assets/images/chart.png" class="pie-chart" />
            </div>
            <div class="desc-box">
              <p class="tit">业财融合数智风控服务</p>
              <p class="info">
                集成业内顶级财务和业务系统，业财融合前置风险管控，AI深度学习智能识别风险点，构建数智风险管控模型。
              </p>
            </div>
          </div>
          <div class="item-box">
            <div class="img-box">
              <img
                src="~@/assets/images/bar_chart_line.png"
                class="pie-chart"
              />
            </div>
            <div class="desc-box">
              <p class="tit">穿透式生态产业链服务</p>
              <p class="info">
                构建“研产销”和“产学研”双向循环，实现信息、资源和技术
                的穿透，在生态产业链的任意点可形成聚集型竞争优势。
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { nextTick, onMounted } from "vue";
import { WOW } from "wowjs";
export default {
  name: "Business",
  setup() {
    onMounted(() => {
      nextTick(() => {
        const wow = new WOW({
          live: false,
        });
        wow.init();
      });
    });
  },
};
</script>
<style lang="scss" scoped>
.business-container {
  font-family: pingfangM;
  p {
    margin: 0;
  }
  .top-box {
    height: 4.1rem;
    background: url(../assets/images/business-bg.png) no-repeat;
    background-size: 100% 100%;
    box-sizing: border-box;
    padding: 1.042rem /* 200/192 */ /* 218/192 */ 0.813rem /* 156/192 */ 0;
    text-align: left;
    .title {
      font-size: 0.115rem /* 26/192 */;
      color: #0eadb1;
    }
    .desc {
      margin-top: 0.208rem /* 40/192 */;
      // font-size: 0.375rem; /* 72/192 */
      font-size: 0.3rem;
      text-align: justify;
      line-height: 1.5;
      font-family: pingfangB;
    }
  }
  .content-box {
    padding: 0.333rem /* 64/192 */ 0.813rem /* 156/192 */ 0;
    .title {
      font-size: 0.25rem /* 48/192 */;
      text-align: left;
    }
    .content {
      display: flex;
    }
    .desc {
      box-sizing: border-box;
      padding-top: 0.283rem /* 112/192 */;
      padding-right: 1.719rem /* 330/192 */;
      width: 50%;
      text-align: left;
      font-size: 0.125rem /* 24/192 */;
      line-height: 1.8;
    }
    .detail {
      width: 50%;
      .item-box {
        display: flex;
        margin-bottom: 0.365rem /* 70/192 */;
        border-bottom: 1px solid #e9e9e9;
        &:last-child {
          border-bottom: none;
        }
        .img-box {
          box-sizing: border-box;
          width: 1.198rem /* 230/192 */;
          padding-right: 0.35rem /* 190/192 */;
          img {
            width: 0.208rem /* 40/192 */;
            height: 0.208rem /* 40/192 */;
          }
          .pie-chart {
            width: 0.25rem /* 48/192 */;
            height: 0.25rem;
          }
        }
        .desc-box {
          text-align: left;
          margin-bottom: 0.365rem /* 70/192 */;
          box-sizing: border-box;
          padding-right: 0.258rem /* 88/192 */;
          .tit {
            font-size: 0.125rem /* 24/192 */;
            line-height: 0.208rem /* 40/192 */;
            margin-bottom: 0.1rem /* 50/192 */;
          }
          .info {
            font-size: 0.094rem /* 18/192 */;
            line-height: 1.8;
          }
        }
      }
    }
  }
}
</style>
